import { Component, EventEmitter, Input, Output } from '@angular/core';
import { getLanguageCookie } from 'src/assets/language';
import { BusinessSolutionsService } from "../../../../services/business-solutions/business-solutions.service";
import { addAlert, apiOfflineAsync } from "../../../../layouts/pages/pages.component";
import { parse } from "circular-json"
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { PageTechnologiesService } from 'src/app/services/page-technologies/page-technologies.service';
import { PersonasService } from 'src/app/services/personas/personas.service';
import { templateBusinessSolutions, templateCrmTree, templatePersonas, templateTechnologies } from 'src/assets/const/templateImportXls';
import { WorkflowService } from 'src/app/services/workflow/workflow.service';
import { CrmTreeService } from 'src/app/services/crm-tree/crm-tree.service';

@Component({
  selector: 'app-import',
  templateUrl: './import.component.html',
  styleUrls: ['./import.component.scss']
})
export class ImportComponent {
  @Output() toggleImportModal: EventEmitter<any> = new EventEmitter<any>();
  @Output() updateFiles: EventEmitter<any> = new EventEmitter<any>();
  @Input() properties: any = {}
  @Input() parameters: any = {}
  @Input() type: string = ''
  selectedFileName: string = '';
  selectedFileHave: boolean = false;
  fileInputRef: any;
  isShowButton = false;
  isLoading = false;

  alert: any

  business_solutions_import: any = {}

  selectedFlag: any = {
    lang: 'en',
    file: 'us.svg'
  };

  xlsFiles: any = []

  template: any = []
  EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

  constructor(
    private businessSolutionsService: BusinessSolutionsService,
    private technologiesService: PageTechnologiesService,
    private personasService: PersonasService,
    private workflowService: WorkflowService,
    private crmTreeService: CrmTreeService
  ) { }

  getLanguages(file: string) {
    return getLanguageCookie(file, localStorage.getItem('language'))
  }

  async exitModal(hide: boolean = true) {
    this.toggleImportModal.emit();
  }

  async modalClose() {
    await Promise.all([this.exitModal()]);
  }

  handleFileInput(event: any) {
    this.xlsFiles = event.target.files;
    this.selectedFileHave = this.xlsFiles && this.xlsFiles.length > 0;
    this.selectedFileName = this.selectedFileHave ? this.xlsFiles[0].name : '';
    this.isShowButton = true;
  }

  clearFileSelection() {
    this.selectedFileName = '';
    this.selectedFileHave = false;

    this.fileInputRef = null; // Limpa o valor do input
    this.xlsFiles = [];
    this.isShowButton = false;
  }

  onFileInputRef(input: any) {
    this.fileInputRef = input;
  }

  async set() {
    switch (this.type) {
      case 'business_solution':
        await this.setBusinessTreeImportXls()
        break;
      case 'crm_tree':
        await this.setCrmTreeImportXls()
        break;
      case 'technologies':
        await this.setTechnologyTreeImportXls()
        break;
      case 'organizational_structure':
        await this.setOrganizationalStructureImportXls()
        break;
      case 'workflow':
        await this.setWorkflowImportXls()
        break;
      default:
        break;
    }
  }

  async getTemplate() {
    switch (this.type) {
      case 'business_solution':
        this.template = templateBusinessSolutions
        this.exportToExcel('business_solution', [
          'Code',
          'Name',
          'Status',
          'Description',
          'StrategicPlanning',
          'Contacts',
          'Phase',
          'FteTab',
          'Procedures',
          'Integrations',
          'FAQ'
        ])
        break;
      case 'technologies':
        this.template = templateTechnologies
        this.exportToExcel('technologies')
        break
      case 'organizational_structure':
        this.template = templatePersonas
        this.exportToExcel('organizational_structure')
        break;
      case 'crm_tree':
        this.template = templateCrmTree
        this.exportToExcel('crm_tree')
        break;
      default:
        break;
    }
  }

  async setBusinessTreeImportXls() {
    this.isLoading = true;
    try {
      const response: any = await this.businessSolutionsService.setBusinessTreeImportXls(this.xlsFiles[0])
      if (response && [201, 202].includes(response.status)) {
        addAlert('success', response.message)
        this.clearFileSelection()

        this.isLoading = false;
        this.business_solutions_import = {}
        this.business_solutions_import.json = parse(response.data)

        this.updateFiles.emit({ files: this.business_solutions_import.json });
      } else {
        addAlert('danger', response.message)
        this.isLoading = false;
        await this.modalClose()
      }
    } catch (error: any) {
      await apiOfflineAsync(error)
    }
    this.isLoading = false;
    await this.modalClose()
  }

  async setCrmTreeImportXls() {
    this.isLoading = true;
    try {
      const response: any = await this.crmTreeService.setCrmTreeImportXls(this.xlsFiles[0])
      if (response && [201, 202].includes(response.status)) {
        addAlert('success', response.message)
        this.clearFileSelection()

        this.isLoading = false;
        this.business_solutions_import = {}
        this.business_solutions_import.json = parse(response.data)

        this.updateFiles.emit({ files: this.business_solutions_import.json });
      } else {
        addAlert('danger', response.message)
        this.isLoading = false;
        await this.modalClose()
      }
    } catch (error: any) {
      await apiOfflineAsync(error)
    }
    this.isLoading = false;
    await this.modalClose()
  }

  async setTechnologyTreeImportXls() {
    this.isLoading = true;
    try {
      const response: any = await this.technologiesService.setTechnologiesImportXls(this.xlsFiles[0])
      if (response && [201, 202].includes(response.status)) {
        addAlert('success', response.message)
        this.clearFileSelection()

        this.isLoading = false;
        this.business_solutions_import = {}
        this.business_solutions_import.json = parse(response.data)

        this.updateFiles.emit({ files: this.business_solutions_import.json });
      } else {
        addAlert('danger', response.message)
        this.isLoading = false;
        await this.modalClose()
      }
    } catch (error: any) {
      await apiOfflineAsync(error)
    }
    this.isLoading = false;
    await this.modalClose()
  }

  async setOrganizationalStructureImportXls() {
    this.isLoading = true;
    try {
      const response: any = await this.personasService.setPersonasImportXls(this.xlsFiles[0])
      if (response && [201, 202].includes(response.status)) {
        addAlert('success', response.message)
        this.clearFileSelection()

        this.isLoading = false;
        this.business_solutions_import = {}
        this.business_solutions_import.json = parse(response.data)

        this.updateFiles.emit({ files: this.business_solutions_import.json });
      } else {
        addAlert('danger', response.message)
        this.isLoading = false;
        await this.modalClose()
      }
    } catch (error: any) {
      await apiOfflineAsync(error)
    }
    this.isLoading = false;
    await this.modalClose()
  }

  async setWorkflowImportXls() {
    this.isLoading = true;
    try {
      const response: any = await this.workflowService.setWorkflowImportXls(this.xlsFiles[0])
      if (response && [201, 202].includes(response.status)) {
        addAlert('success', response.message)
        this.clearFileSelection()

        this.isLoading = false;
        this.business_solutions_import = {}
        this.business_solutions_import.json = parse(response.data)

        this.updateFiles.emit({ files: this.business_solutions_import.json });
      } else {
        addAlert('danger', response.message)
        this.isLoading = false;
        await this.modalClose()
      }
    } catch (error: any) {
      await apiOfflineAsync(error)
    }
    this.isLoading = false;
    await this.modalClose()
  }

  exportToExcel(name: string, header: any[] = []): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.template, {
      header: header
    });

    const workbook: XLSX.WorkBook = { Sheets: { 'Data': worksheet }, SheetNames: ['Data'] };

    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    this.saveExcelFile(excelBuffer, name);
  }

  private saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: this.EXCEL_TYPE });
    saveAs(data, `${fileName}_template.xls`);
  }
}
